import React, { useEffect, useState } from 'react';
import { useGame } from 'context/GameContext';
import ReactMarkdown from 'react-markdown';
import { config, useSpring } from 'react-spring';
import * as Styled from './Message.style';
import Debug from 'debug';
const debug = Debug('message');

const Message = () => {
  const { gameState } = useGame();
  const { message } = gameState;

  const [visible, setVisible] = useState(false);
  const styles = useSpring({
    config: config.molasses,
    opacity: visible ? 1 : 0
  });

  useEffect(() => {
    if (message) {
      debug(message?.label ?? message);
      setVisible(true);
      // Hide the message after a delay
      const timeout = setTimeout(() => setVisible(false), 3000); // Adjust duration as needed
      return () => clearTimeout(timeout);
    }
  }, [message]);

  return (
    <Styled.Message style={styles}>
      <ReactMarkdown>{message?.label || message}</ReactMarkdown>
    </Styled.Message>
  );
};

export default Message;
